import { createStandardAction } from 'typesafe-actions';
import { IDocument } from '../api';

interface ITranscriptMeta {
  trackID: string,
}

export const fetchTranscriptRequest = createStandardAction('FETCH_TRANSCRIPT_REQUEST')<void, ITranscriptMeta>();
export const fetchTranscriptSuccess = createStandardAction('FETCH_TRANSCRIPT_SUCCESS')<IDocument, ITranscriptMeta>();
export const fetchTranscriptFailure = createStandardAction('FETCH_TRANSCRIPT_FAILURE')<Error, ITranscriptMeta>();

export const selectTranscript = createStandardAction('SELECT_TRANSCRIPT')<string>();



// WEBPACK FOOTER //
// ./src/actions/transcriptActions.ts